export const AppWrapper = ({ children }) => (
  <div className="app-wrapper" style={{ marginTop: "200px" }}>
    {children}
  </div>
);
